import { UiTrackingDetails } from '@parship/psg-interfaces';

export default class UiTracking {
	private static getCategory(): string {
		switch (document.body.id) {
			case 'homepage':
				return 'homepage';
			case 'landing-page':
				return 'landing-page';
			default:
				return 'editorial';
		}
	}
	public static trackUIEvent(
		subcategory: string,
		targetId: string,
		action: string,
		cd1: string = '',
		cd2: string = '',
		cd3: string = ''
	): void {
		const detail: UiTrackingDetails = {
			category: this.getCategory(),
			subcategory,
			targetId,
			action,
			cd1,
			cd2,
			cd3,
		};

		document.dispatchEvent(new CustomEvent('pegLogger-logWpEvents', { detail }));
	}
}
